import styled from "styled-components";
import { Link } from "react-router-dom";

export const ServicesContainer = styled.div`
    height: auto;
    min-height: 900px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #010606;
    padding: 140px 0;

    @media screen and (max-width: 1000px) {
        padding: 120px 0;
        min-height: 1100px;
    }

    @media screen and (max-width: 768px) {
        padding: 100px 0;
        min-height: 1700px;
    }

    @media screen and (max-width: 480px) {
        padding: 80px 0;
        min-height: 1650px;
    }
`;

export const ServicesWrapper = styled.div`
    max-width: 1400px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    align-items: stretch;
    grid-gap: 40px;
    padding: 0 60px;

    @media screen and (max-width: 1000px) {
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 32px;
        padding: 0 40px;
    }

    @media screen and (max-width: 768px) {
        grid-template-columns: 1fr;
        padding: 0 24px;
        grid-gap: 24px;
    }

    @media screen and (max-width: 480px) {
        padding: 0 20px;
        grid-gap: 20px;
    }
`;

export const ServicesCard = styled(Link)`
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    border-radius: 20px;
    padding: 40px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.2);
    transition: all 0.2s ease-in-out;
    text-decoration: none;
    color: #000;
    height: 100%;

    &:hover {
        transform: scale(1.05);
        transition: all 0.2s ease-in-out;
        cursor: pointer;
    }
`;

export const ServicesCardLink = styled.a`
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    border-radius: 20px;
    padding: 40px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.2);
    transition: all 0.2s ease-in-out;
    text-decoration: none;
    color: #000;
    height: 100%;

    &:hover {
        transform: scale(1.05);
        transition: all 0.2s ease-in-out;
        cursor: pointer;
    }
`;

export const ServicesIcon = styled.img`
    height: 160px;
    width: 160px;
    margin-bottom: 32px;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

    @media screen and (max-width: 768px) {
        height: 120px;
        width: 120px;
        margin-bottom: 24px;
    }

    @media screen and (max-width: 480px) {
        height: 100px;
        width: 100px;
        margin-bottom: 20px;
    }
`;

export const ServicesH1 = styled.h1`
    font-size: 56px;
    color: #fff;
    margin-bottom: 20px;
    font-weight: 700;
    text-align: center;
    letter-spacing: -1.5px;
    line-height: 1.1;

    @media screen and (max-width: 768px) {
        font-size: 44px;
        letter-spacing: -1px;
    }

    @media screen and (max-width: 480px) {
        font-size: 36px;
        letter-spacing: -0.5px;
    }
`;

export const ServicesH2 = styled.h2`
    font-size: 22px;
    margin-bottom: 20px;
    font-weight: 600;
    text-align: center;
    color: #1a1a1a;
    line-height: 1.3;
    letter-spacing: -0.3px;

    @media screen and (max-width: 768px) {
        font-size: 20px;
        margin-bottom: 16px;
    }

    @media screen and (max-width: 480px) {
        font-size: 18px;
        margin-bottom: 14px;
    }
`;

export const ServicesP = styled.p`
    font-size: 17px;
    text-align: center;
    line-height: 1.6;
    color: #666;
    margin: 0;
    flex-grow: 1;
    letter-spacing: 0.1px;

    @media screen and (max-width: 768px) {
        font-size: 16px;
        line-height: 1.6;
    }

    @media screen and (max-width: 480px) {
        font-size: 15px;
        line-height: 1.6;
    }
`;

export const ServicesH3 = styled.h3`
    font-size: 20px;
    margin-bottom: 80px;
    color: #38A7BA;
    font-weight: 500;
    text-align: center;
    opacity: 0.9;
    letter-spacing: 0.2px;

    @media screen and (max-width: 768px) {
        font-size: 18px;
        margin-bottom: 60px;
    }

    @media screen and (max-width: 480px) {
        font-size: 16px;
        margin-bottom: 40px;
    }
`;
